import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const AppointmentsLayout = () => import('./AppointmentsLayout.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      component: AppointmentsLayout,
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: FEATURE_FLAGS.APPOINTMENTS_MODULE,
      },
      children: [
        {
          path: '',
          name: 'appointments_root',
          redirect: { name: 'appointments_calendar' },
        },
        {
          path: 'dashboard',
          name: 'appointments_dashboard',
          component: () => import('./AgendaDashboard.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'agenda',
          name: 'appointments_agenda',
          component: () => import('./AgendaActivitiesList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'calendar',
          name: 'appointments_calendar',
          component: () => import('./AgendaCalendarView.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'kanban',
          name: 'appointments_kanban',
          component: () => import('./AgendaKanbanView.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'clients',
          name: 'appointments_clients',
          component: () => import('./AppointmentsClientsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'professionals',
          name: 'appointments_professionals',
          component: () => import('./AppointmentsProfessionalsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'services',
          name: 'appointments_services',
          component: () => import('./AppointmentsServicesList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'partners',
          name: 'appointments_partners',
          component: () => import('./AppointmentsPartnersList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'office',
          name: 'appointments_office',
          component: () => import('./AgendaEscritorio.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'rescheduling',
          name: 'appointments_rescheduling',
          component: () => import('./AppointmentsRescheduling.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'reports',
          name: 'appointments_reports',
          component: () => import('./AgendaRelatorios.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
      ],
    },
  ],
};
